import { StatusBuilder } from './Components/FiltersBuilder/StatusBuilder';

export const DEAL_FILTER_CONFIG = [
  {
    title: 'Status',
    value: 'step',
    builder: StatusBuilder,
  },
];
